// src/components/PageHeader.jsx

import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PageHeader({ title, children, backTo = -1 }) {
  const navigate = useNavigate();
  const location = useLocation();

  // 1. Verificamos se a localização atual é a página inicial.
  const isHomePage = location.pathname === '/';

  // 2. Função de navegação inteligente
  const handleGoBack = () => {
    navigate(backTo);
  };

  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="flex items-center gap-4">
        {/* 3. O botão de voltar só aparece se NÃO estivermos na página inicial */}
        {!isHomePage && (
          <button
            onClick={handleGoBack}
            className="rounded-full p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-200"
            aria-label="Voltar"
          >
            <ArrowLeft className="h-6 w-6" />
          </button>
        )}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          {title}
        </h1>
      </div>
      
      {/* 'children' é onde os botões de ação (como "Registrar Encomenda") são renderizados */}
      <div>{children}</div>
    </div>
  );
}
